import { BankAccount } from "./account";
import { Assessment } from "./assessment";
import { Collaborator } from "./collaborator";
import { Collection } from "./collection";
import { Lecture } from "./lecture";

export interface Enrollment {
  id: number;
  student_id: number;
  name: string;
  email: string;
  reg_number: string;
  enrollment_date: string;
  expiry_date: string;
}
export enum PayoutStatus {
  PENDING = 0,
  ERROR = 1,
  SUCCESSFUL = 2
}
export interface Payout {
  id: number;
  amount: number;
  status: PayoutStatus;
  reference: string;
  time: string;
  bank_account_details: BankAccount
}

export interface Classroom {
  id: number;
  name: string;
  description: any;
  image: string;
  image_file: File | null,
  enrollment_code: string;
  instructor_amount: number;
  enrollment_type: number;
  duration: number;
  instructor_id: number;
  earnings: number;
  enrollment_count: number;
  created_on: string;
  collaborators: Record<number, Collaborator> | null;
  lectures: Record<number, Lecture> | null;
  assessments: Record<number, Assessment> | null;
  collections: Record<number, Collection> | null;
  enrollments: Enrollment[] | null;
  payouts: Payout[] | null;
  removed_image: string;
}
  
export const CreateNewClassroom = (): Classroom => ({
  id: 0,
  name: '',
  description: {},
  image: '',
  image_file: null,
  enrollment_code: '',
  instructor_amount: 0,
  enrollment_type: 0,
  duration: 0,
  instructor_id: 0,
  earnings: 0,
  enrollment_count: 0,
  created_on: '',
  collaborators: [],
  lectures: [],
  assessments: [],
  collections: [],
  enrollments: [],
  payouts: [],
  removed_image: ''
});
  
export function createClassroomPayload(classroom: Classroom) {
  return {
    name: classroom.name,
    // description: classroom.description,
    // image: classroom.image,
    instructor_amount: classroom.instructor_amount || null,
    enrollment_type: classroom.enrollment_type,
    duration: classroom.duration || null,
  };
}

export function updateClassroomPayload(classroom: Classroom) {
  return {
    id: classroom.id,
    name: classroom.name,
    description: classroom.description,
    image: classroom.image,
    instructor_amount: classroom.instructor_amount || null,
    enrollment_type: classroom.enrollment_type,
    duration: classroom.duration || null,
    removed_image: classroom.removed_image || null,
  };
}
